import { Controller, useFormContext } from 'react-hook-form';
import { Input } from '@ds';
import { DonorFormRow } from './DonorFormRow';
import { DonorProfileFormValues } from '../types';
import { createOrganField, OrganScopedSectionProps } from '../organField';

export const MatchIdRow = ({ namePrefix }: OrganScopedSectionProps) => {
  const { control } = useFormContext<DonorProfileFormValues>();
  const organField = createOrganField(namePrefix);

  return (
    <DonorFormRow title="Match ID">
      <div className="w-[332px]">
        <Controller
          name={organField('matchId')}
          control={control}
          render={({ field: matchIdField, fieldState: { invalid, error } }) => (
            <Input
              placeholder="Enter Match ID"
              aria-label="Match ID"
              isInvalid={invalid}
              errorMessage={error?.message}
              {...matchIdField}
              value={matchIdField.value ?? ''}
            />
          )}
        />
      </div>
    </DonorFormRow>
  );
};
